<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  mounted () {
    document.addEventListener('submit', this.preventSingleFieldFormRefresh, true)
  },
  beforeDestroy () {
    document.removeEventListener('submit', this.preventSingleFieldFormRefresh, true)
  },
  methods: {
    preventSingleFieldFormRefresh (event) {
      const form = event.target
      if (!form.classList || !form.classList.contains('el-form')) return
      const fieldItems = Array.from(form.querySelectorAll('.el-form-item'))
        .filter(item => item.getClientRects().length && item.querySelector('input:not([type="hidden"]), textarea, select'))
      if (fieldItems.length === 1) event.preventDefault()
    }
  }
}
</script>

<style lang="scss">
// 测试远程端是否链接成功
</style>
